// extracted by mini-css-extract-plugin
export default {"root":"Category_root__KTgyw","label":"Category_label__q6N4D","active":"Category_active__n0FwU"};